/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React, { useState } from 'react'
import { getLayoutFromLocalStorage, ILayout, LayoutSetup } from '../../../_metronic/layout/core'
import { ListProduct } from './componentes/ListProduct'
import { DatosConfirmacion } from './componentes/DatosConfirmacion'
import { Revision } from './componentes/Revision'
import { useQueryResponseData } from '../../modules/apps/productos-management/users-list/core/QueryResponseProvider'


const BuilderPage: React.FC = () => {

  const [tab, setTab] = useState('Productos')
  const [config, setConfig] = useState<ILayout>(getLayoutFromLocalStorage())
  const [configLoading, setConfigLoading] = useState<boolean>(false)
  const [resetLoading, setResetLoading] = useState<boolean>(false)
  const productos = useQueryResponseData()
  console.log(productos, "modal")

  localStorage.setItem("productos", JSON.stringify(productos))
  const updateConfig = () => {
    setConfigLoading(true)

    try {
      LayoutSetup.setConfig(config)
      window.location.reload()
    } catch (error) {
      setConfig(getLayoutFromLocalStorage())
      setConfigLoading(false)
    }
  }

  const reset = () => {
    setResetLoading(true)
    setTimeout(() => {
      setConfig(getLayoutFromLocalStorage())
      setResetLoading(false)
    }, 1000)
  }

  return (
    <>

      <div className='card card-custom'>
        {/* Encabezado en donde aquí maneja el estado "tab", este manejo nos ayudará a darle funcionalidad al tab*/}
        <div className='card-header card-header-stretch overflow-auto'>
          <ul className='nav nav-stretch nav-line-tabs fw-bold border-transparent flex-nowrap' role='tablist'>
            <li className='nav-item'>
              <a className={clsx(`nav-link cursor-pointer`, { active: tab === 'Productos' })} onClick={() => setTab('Productos')} role='tab'>Productos</a>
            </li>
            <li className='nav-item'>
              <a className={clsx(`nav-link cursor-pointer`, { active: tab === 'Datos' })} onClick={() => setTab('Datos')} role='tab'>Datos</a>
            </li>
            <li className='nav-item'>
              <a className={clsx(`nav-link cursor-pointer`, { active: tab === 'Revision' })} onClick={() => setTab('Revision')} role='tab'> Revisión </a>
            </li>
          </ul>
        </div>

        <form className='form'>
          <div className='card-body'>
            <div className='tab-content'>
              <div className={clsx('tab-pane', { active: tab === 'Productos' })}>
                <div className='form-group d-flex flex-stack'>
                  <ListProduct />
                </div>
                <div className='d-flex justify-content-end mt-5'>
                  <button type='button' id='kt_layout_builder_reset' className='btn btn-primary me-4' onClick={() => setTab('Datos')} >
                    <span>Siguiente</span>
                  </button>
                </div>
              </div>

              <div className={clsx('tab-pane', { active: tab === 'Datos' })}>
                <DatosConfirmacion />
                <div className='d-flex justify-content-end mt-5'>
                  <button type='button' id='kt_layout_builder_reset' className='btn btn-primary me-4' onClick={() => setTab('Revision')} >
                    <span>Siguiente</span>
                  </button>
                </div>

              </div>

              <div className={clsx('tab-pane', { active: tab === 'Revision' })}>
                <Revision />
                <div className='row'>

                  <div className='d-flex justify-content-end mt-5'>
                    <button type='button' id='kt_layout_builder_reset' className='btn btn-active-secondary btn-color-muted me-4' onClick={reset} >
                      {!resetLoading && <span className='indicator-label'>Reestablecer</span>}
                      {resetLoading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          Reestableciendo...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                    <button type='button' onClick={updateConfig} className='btn btn-primary me-2'>
                      {!configLoading && <span className='indicator-label'>Crear</span>}
                      {configLoading && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          Creando Orden...{' '}
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* <div className='card-footer py-6'>
              <div className='row'>
                
                <div className='d-flex justify-content-end'>
                  <button type='button' id='kt_layout_builder_reset' className='btn btn-active-secondary btn-color-muted me-4' onClick={reset} >
                    {!resetLoading && <span className='indicator-label'>Reestablecer</span>}
                    {resetLoading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <button type='button' onClick={updateConfig} className='btn btn-primary me-2'>
                    {!configLoading && <span className='indicator-label'>Siguiente</span>}
                    {configLoading && (
                      <span className='indicator-progress' style={{display: 'block'}}>
                        Please wait...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div> */}
          </div>
        </form>
      </div>
    </>
  )
}

export { BuilderPage }
